import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';

import BaseResponse from '../../models/src/model/BaseResponse';
import {
  EventsControllerDtoEventInvitationHistoryListRequest, EventsControllerDtoEventInvitationInfosAddBudgetRequest,
  EventsControllerDtoEventInvitationInfosCreateRequest, EventsControllerDtoEventInvitationInfosDepositRequest,
  EventsControllerDtoEventInvitationInfosDetailRequest,
  EventsControllerDtoEventInvitationInfosListRequest,
  EventsControllerDtoEventInvitationInfosRemoveRequest,
  EventsControllerDtoEventInvitationInfosUpdateRequest, EventsControllerDtoEventInvitationRewardListRequest,
  PerplayEventsApi,
} from '../../models/src';
import {
  invitationEventResponse,
} from '../../actions/event/invitationEventActions';
import {
  INVITATION_EVENT_ADD_BUDGET,
  INVITATION_EVENT_CREATE_REQUEST,
  INVITATION_EVENT_DEPOSIT_REQUEST,
  INVITATION_EVENT_INFO_DELETE_REQUEST,
  INVITATION_EVENT_INFO_DETAILS_REQUEST,
  INVITATION_EVENT_INFO_HISTORY_REQUEST, INVITATION_EVENT_INFO_REWARD_REQUEST,
  INVITATION_EVENT_INFO_UPDATE_REQUEST,
  INVITATION_EVENT_LIST_REQUEST,
} from '../../constants/event/invitationEventConstants';
import changeNumApi from '../../../api/ui/changeNumApi';
import EventsControllerDtoEventInvitationInfosListResponse
  from '../../models/src/model/EventsControllerDtoEventInvitationInfosListResponse';
import EventsControllerDtoEventInvitationInfosDetailResponse
  from '../../models/src/model/EventsControllerDtoEventInvitationInfosDetailResponse';
import EventsControllerDtoEventInvitationHistoryListResponse
  from '../../models/src/model/EventsControllerDtoEventInvitationHistoryListResponse';
import EventsControllerDtoEventInvitationRewardListResponse
  from '../../models/src/model/EventsControllerDtoEventInvitationRewardListResponse';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
const api = new PerplayEventsApi(config.API_CLIENT);

function* invitationEventListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new EventsControllerDtoEventInvitationInfosListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayEventsEventInvitationInfosListPost({ eventsControllerDtoEventInvitationInfosListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, EventsControllerDtoEventInvitationInfosListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* invitationEventCreateRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new EventsControllerDtoEventInvitationInfosCreateRequest();
    requestData.invNo = payload.invNo;
    requestData.invitationLimit = payload.invitationLimit;
    requestData.regDuration = payload.regDuration;
    requestData.inviterXper = payload.inviterXper;
    requestData.inviterPer = payload.inviterPer;
    requestData.inviterItem1 = payload.inviterItem1;
    requestData.inviterItem1Count = payload.inviterItem1Count;
    requestData.inviterItem2 = payload.inviterItem2;
    requestData.inviterItem2Count = payload.inviterItem2Count;
    requestData.invitedXper = payload.invitedXper;
    requestData.invitedPer = payload.invitedPer;
    requestData.invitedItem1 = payload.invitedItem1;
    requestData.invitedItem1Count = payload.invitedItem1Count;
    requestData.invitedItem2 = payload.invitedItem2;
    requestData.invitedItem2Count = payload.invitedItem2Count;
    // requestData.walletNo = payload.walletNo;
    requestData.beginAt = payload.beginAt;
    requestData.endAt = payload.endAt;
    requestData.createdAt = payload.createdAt;
    // requestData.depositTransactionStatus = payload.depositTransactionStatus;
    requestData.eventType = payload.eventType;
    // requestData.initialPer = payload.initialPer;
    // requestData.initialXper = payload.initialXper;
    requestData.rewardRatio = payload.rewardRatio;
    requestData.rewardLimit = payload.rewardLimit;
    requestData.tokenType = payload.tokenType;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayEventsEventInvitationInfosCreatePost({ eventsControllerDtoEventInvitationInfosCreateRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* invitationEventInfoDetailsRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new EventsControllerDtoEventInvitationInfosDetailRequest();
    requestData.invNo = payload.invNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayEventsEventInvitationInfosDetailPost({ eventsControllerDtoEventInvitationInfosDetailRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, EventsControllerDtoEventInvitationInfosDetailResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* invitationEventHistoryListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new EventsControllerDtoEventInvitationHistoryListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.invNo = payload.invNo;
    requestData.searchType = payload.searchType;
    requestData.searchString = payload.searchString;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayEventsEventInvitationHistoryListPost({ eventsControllerDtoEventInvitationHistoryListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, EventsControllerDtoEventInvitationHistoryListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* invitationEventRewardListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new EventsControllerDtoEventInvitationRewardListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.invNo = payload.invNo;
    requestData.searchType = payload.searchType;
    requestData.searchString = payload.searchString;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayEventsEventInvitationRewardListPost({ eventsControllerDtoEventInvitationRewardListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, EventsControllerDtoEventInvitationRewardListResponse);
    console.log("data: ", data);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* invitationEventUpdateRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new EventsControllerDtoEventInvitationInfosUpdateRequest();
    requestData.invNo = payload.invNo;
    requestData.invitationLimit = payload.invitationLimit;
    requestData.regDuration = payload.regDuration;
    requestData.inviterXper = payload.inviterXper;
    requestData.inviterItem1 = payload.inviterItem1;
    requestData.inviterItem1Count = payload.inviterItem1Count;
    requestData.inviterItem2 = payload.inviterItem2;
    requestData.inviterItem2Count = payload.inviterItem2Count;
    requestData.invitedXper = payload.invitedXper;
    requestData.invitedItem1 = payload.invitedItem1;
    requestData.invitedItem1Count = payload.invitedItem1Count;
    requestData.invitedItem2 = payload.invitedItem2;
    requestData.invitedItem2Count = payload.invitedItem2Count;
    requestData.beginAt = payload.beginAt;
    requestData.endAt = payload.endAt;
    requestData.initialPer = payload.initialPer;
    requestData.initialXper = payload.initialXper;
    requestData.rewardLimit = payload.rewardLimit;
    requestData.rewardRatio = payload.rewardRatio;
    console.log('변경 요청 데이터: ', requestData);

    const result = yield api.apiPerplayEventsEventInvitationInfosUpdatePost({ eventsControllerDtoEventInvitationInfosUpdateRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* invitationEventDeleteRequestSaga(payload) {
  try {
    const requestData = new EventsControllerDtoEventInvitationInfosRemoveRequest();
    requestData.invNo = payload.invNo;
    const result = yield api.apiPerplayEventsEventInvitationInfosRemovePost(
        { eventsControllerDtoEventInvitationInfosRemoveRequest: requestData },
        () => {},
    );
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log('data: ', data);

    if (data.resultCode === 200) {
      payload.callback(data);
      yield put(invitationEventResponse(data.resultCode, '이벤트 삭제 성공.'));
    } else {
      yield put(
        invitationEventResponse(
          data.resultCode,
          `${data.description}으로 삭제 실패 로그확인 필요.`,
        ),
      );
    }
  } catch (e) {
    console.log(e);
  }
}

function* invitationEventDepositRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new EventsControllerDtoEventInvitationInfosDepositRequest();
    requestData.invNo = payload.invNo;
    requestData.tokenType = payload.tokenType;
    requestData.transactionHash = payload.transactionHash;
    const result = yield api.apiPerplayEventsEventInvitationInfosDepositPost({ eventsControllerDtoEventInvitationInfosDepositRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* invitationEventAddBudgetRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new EventsControllerDtoEventInvitationInfosAddBudgetRequest();
    requestData.invNo = payload.invNo;
    requestData.addXper = payload.addXper;
    requestData.addPer = payload.addPer;
    requestData.transactionHash = payload.transactionHash;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayEventsEventInvitationInfosAddBudgetPost({ eventsControllerDtoEventInvitationInfosAddBudgetRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* invitationEventRootSaga() {
  yield all([
    takeEvery(INVITATION_EVENT_LIST_REQUEST, invitationEventListRequestSaga),
    takeEvery(INVITATION_EVENT_CREATE_REQUEST, invitationEventCreateRequestSaga),
    takeEvery(INVITATION_EVENT_INFO_DETAILS_REQUEST, invitationEventInfoDetailsRequestSaga),
    takeEvery(INVITATION_EVENT_INFO_HISTORY_REQUEST, invitationEventHistoryListRequestSaga),
    takeEvery(INVITATION_EVENT_INFO_REWARD_REQUEST, invitationEventRewardListRequestSaga),
    takeEvery(INVITATION_EVENT_INFO_UPDATE_REQUEST, invitationEventUpdateRequestSaga),
    takeEvery(INVITATION_EVENT_INFO_DELETE_REQUEST, invitationEventDeleteRequestSaga),
    takeEvery(INVITATION_EVENT_DEPOSIT_REQUEST, invitationEventDepositRequestSaga),
    takeEvery(INVITATION_EVENT_ADD_BUDGET, invitationEventAddBudgetRequestSaga),
  ]);
}

const invitationEventSagas = [fork(invitationEventRootSaga)];

export default invitationEventSagas;
